<template>
  <div>
    <v-layout column>
      <v-flex xs12>
        <w-schema :model="schema.login">
          <v-text-field
            name="login"
            label="Nazwa Użytkownika (Adres e-mail) *"
            :readonly="edit"
            :hint="edit ? 'Nie można zmienić nazwy użytkownika' : 'Nazwa użytkownika używana do logowania do systemu'"
          ></v-text-field>
        </w-schema>
      </v-flex>

      <v-flex xs12>
        <v-layout row wrap>
          <v-flex pr-2 xs6>
            <w-schema :model="schema.profile.firstName">
              <v-text-field name="firstName" label="Imię użytkownika *"></v-text-field>
            </w-schema>
          </v-flex>

          <v-flex pl-2 xs6>
            <w-schema :model="schema.profile.lastName">
              <v-text-field name="lastName" label="Nazwisko użytkownika *"></v-text-field>
            </w-schema>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 v-if="!simple">
        <w-schema :model="schema.profile.pesel">
          <v-text-field name="pesel" label="Pesel *"></v-text-field>
        </w-schema>
      </v-flex>

      <v-flex xs12 v-if="!simple">
        <w-schema :model="schema.profile.phoneNumber">
          <v-text-field name="phoneNumber" label="Numer telefonu *"></v-text-field>
        </w-schema>
      </v-flex>

      <teryt-form v-if="show && !simple" :required="true" :schema="schema.profile"></teryt-form>

      <v-flex xs12>
        <v-layout row wrap>
          <v-flex pr-2 xs6 v-if="!simple">
            <w-schema :model="schema.profile.homeNumber">
              <v-text-field name="homeNumber" label="Numer budynku *"></v-text-field>
            </w-schema>
          </v-flex>

          <v-flex pl-2 xs6 v-if="!simple">
            <w-schema :model="schema.profile.localNumber">
              <v-text-field name="localNumber" label="Numer lokalu"></v-text-field>
            </w-schema>
          </v-flex>
        </v-layout>
      </v-flex>

      <v-flex xs12 v-if="!simple">
        <w-schema :model="schema.profile.postalCode">
          <v-text-field name="postalCode" label="Kod pocztowy *"></v-text-field>
        </w-schema>
      </v-flex>

      <v-flex v-if="!simple">
        <w-schema :model="schema.profile.confirmReason">
          <v-select item-text="text" item-value="value" label="Powód akceptacji*" :items="list"></v-select>
        </w-schema>
      </v-flex>

      <v-flex xs12 v-if="!simple">
        <w-schema :model="schema.profile.confirmReasonDescription">
          <v-textarea
            name="confirmReasonDescription"
            label="Powód akceptacji - dodatkowe informacje"
          ></v-textarea>
        </w-schema>
      </v-flex>

      <v-flex v-if="show" xs12 md6>
        <single-image :schema="schema.profile.mainImage"></single-image>
      </v-flex>
    </v-layout>

    <span class="caption grey--text">* - Pole wymagane</span>
  </div>
</template>

<script>
import { WSchema } from '@witkac/vuetify-components';
import { mapState } from 'vuex';

import TerytForm from '@/components/forms/TERYTForm';
import SingleImage from '@/components/forms/SingleImage';

// @vuese
// Formularz dodawnia/edycji profilu klienta
// @group Client-Profile
export default {
  components: {
    WSchema,
    TerytForm,
    SingleImage
  },
  props: {
    // Schema
    schema: {
      type: Object,
      required: true
    },
    // Czy wyświetlić tylko wymagane pola?
    simple: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy edycja?
    edit: {
      type: Boolean,
      required: false,
      default: false
    },
    // Czy modal otwarty?
    show: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  computed: mapState({
    list: state => {
      const setting = state.settings.settings.PROFILE_CONFIRM_LIST;
      if (setting) {
        return JSON.parse(setting.value).list;
      }
    }
  }),
  created() {
    if (!this.simple) {
      this.$store
        .dispatch('settings/settingFind', 'PROFILE_CONFIRM_LIST')
        .catch(error => this.$store.dispatch('notifyError', { title: 'Nie udało się pobrać danych ustawień.' }));
    }
  }
};
</script>

<style>
</style>
